import { Injectable } from '@angular/core';

export class ComparisonVersionMappingEntry {
  id?: number;
  version?: number;
}

@Injectable({ providedIn: 'root' })
export class ComparisonDataService {

  setPackagingVersionMapping(packagingParts: number[]) {
    const versionMapping: ComparisonVersionMappingEntry[] = [];
    if (!packagingParts || packagingParts.length === 0) { return; }
    packagingParts.forEach(id => versionMapping.push({ id: id, version: 0 }));
    localStorage.setItem('versionMappingForComparison', JSON.stringify(versionMapping));
  }

  getPackagingVersionMapping(): ComparisonVersionMappingEntry[] {
    const versionMapping = localStorage.getItem('versionMappingForComparison');
    return versionMapping ? JSON.parse(versionMapping) : '';
  }
}
